import React, { Fragment } from 'react';
import '../../_assets/css/file.css';
import './style.css';

import { Form } from "react-bootstrap";
import axios from 'axios';
import ReactDatatable from '@ashvin27/react-datatable';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { TOKEN } from '../../_helpers/exports';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
// import { Customers } from './customer_view';
import Input from 'react-phone-number-input/input'
import { Link } from 'react-router-dom';
import Alert from '../../shared/components/Alert';
// import CreateAddress from '../Address/createCustomerAddress';
import * as moment from 'moment';
import Modal from 'react-modal';

import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import { FormControl } from 'react-bootstrap'

import RefreshIcon from 'mdi-react/RefreshCircleIcon';

class SMS extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };
    constructor(props) {
        super(props)
        this.getDataUpdate = this.getDataUpdate.bind(this);
        this.handleFromDateUpdate = this.handleFromDateUpdate.bind(this);
        this.handleToDateUpdate = this.handleToDateUpdate.bind(this);
        this.applyCallback = this.applyCallback.bind(this);

        this.state = {
            showComponent: false,
            hideComponent: true,
            moreinfo: false,
        };
        this.state = {
            isLoading: false,
            isShowError: false,
            isOpen: false,
            statusMessage: '',
            showError: false,
        }
        let now = new Date();
        let start = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
        let end = moment(start).add(1, "days").subtract(1, "seconds");
        this.state = {
            start: start,
            end: end
        }


        this.columns = [
            {
                key: "agent_name",
                TrOnlyClassName: 'tsc',
                text: "Name",
                className: "cell",
                align: "left"
            },
            {
                key: "agent_id",
                TrOnlyClassName: 'tsc',
                text: "Agent ID",
                className: "tsc",
                align: "left"
            },
            {
                key: "mmsisdn",
                TrOnlyClassName: 'tsc',
                text: "Phone#",
                className: "tsc",
                altrueign: "left"
            },
            {
                key: "message",
                TrOnlyClassName: 'tsc',
                text: "Message",
                className: "tsc",
                align: "left"
            },
            {
                key: "time",
                TrOnlyClassName: 'tsc',
                text: "Date Created",
                className: "cell",
                align: "left"
            }

        ]
        this.config = {
            key_column: "tsc",
            length_menu: [10, 20, 50],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 10,
            show_length_menu: true,
            language: {
                loading_text: "Please be patient while data loads...",
                filter: "Search...",
                no_data_text: "No data was found",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            }

        }
    }

    handleFromDateUpdate(date) {
        this.setState({
            startDate: date.date
        })
    }
    handleToDateUpdate(date) {
        this.setState({
            endDate: date.date
        })
    }

    getDataUpdate() {
        this.getData()
    }
    componentDidMount() {
        this.getData();
    }


    getData = (queryString = "") => {
        let formData = {
            "session_id": TOKEN
        }

        this.setState({
            isLoading: true,
        })
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "Authorization": TOKEN
            }
        };
        let url = baseURL + "get_sms_notifications"
        axios.all([
            axios.post(url, formData),
        ]).then(axios.spread((agentResponse) => {
            this.setState({
                agent: agentResponse.data.sms_notifications,
                isLoading: false
            }, function () {
                var data = [];

                this.setState({
                    total: agentResponse.data.sms_notifications.length
                })

                for (let i = 0; i < this.state.agent.length; i++) {


                    let agent_id = { agent_id: this.state.agent[i].agent.id.toString() };
                    let agent_name = { agent_name: this.state.agent[i].agent.name.toString() };
                    let mmsisdn = { mmsisdn: this.state.agent[i].agent.msisdn.toString() };

                    // let mreversed = { mreversed: this.state.agent[i].reversed.toString() };
                    // let mreversed = { mreversed: this.state.agent[i].reversed.toString() };
                    // let mreversed = { mreversed: this.state.agent[i].reversed.toString() };


                    data.push(Object.assign(mmsisdn, agent_id, agent_name, this.state.agent[i]));
                    this.setState({
                        data: data
                    })
                }
            })
        })).catch(error => {
            console.log('bayoo', error.response)

        })
    }
    getData2 = (start, end) => {

        let Sdate = moment(start).format('YYYY-MM-DD HH:mm:ss');
        let Edate = moment(end).format('YYYY-MM-DD HH:mm:ss');
        let formData = {
            "session_id": TOKEN
        }

        this.setState({
            isLoading: true,
        })
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "Authorization": TOKEN
            }
        };
        let url = baseURL + "get_sms_notifications"
        axios.all([
            axios.post(url, formData),
        ]).then(axios.spread((agentResponse) => {
            this.setState({
                agent: agentResponse.data.sms_notifications,
                isLoading: false
            }, function () {
                var data = [];

                this.setState({
                    total: agentResponse.data.sms_notifications.length
                })

                for (let i = 0; i < this.state.agent.length; i++) {


                    let agent_id = { agent_id: this.state.agent[i].agent.id.toString() };
                    let agent_name = { agent_name: this.state.agent[i].agent.name.toString() };
                    let mmsisdn = { mmsisdn: this.state.agent[i].agent.msisdn.toString() };

                    // let mreversed = { mreversed: this.state.agent[i].reversed.toString() };
                    // let mreversed = { mreversed: this.state.agent[i].reversed.toString() };
                    // let mreversed = { mreversed: this.state.agent[i].reversed.toString() };


                    data.push(Object.assign(mmsisdn, agent_id, agent_name, this.state.agent[i]));
                    this.setState({
                        data: data
                    })
                }
            })
        })).catch(error => {
            console.log('bayoo', error.response)

        })
    }
    applyCallback(startDate, endDate) {

        this.getData2(startDate, endDate);

        // alert(startDate)

        // this.setState({
        //     start: startDate,
        //     end: endDate
        // })

        //  alert(this.state.start)
    }



    toggleModal = e => {
        this.setState({
            isOpen: true,
        });
    };

    closeModal = e => {
        this.setState({
            isOpen: false,
        });
    };

    closeModal2 = e => {
        this.getData2();
        this.setState({
            isOpen: false,
        });
    };
    render() {
        const { showComponent, agent_name, agent_msisdn, agent_email, agent_status, account_cash, account_commission, account_float, bank_acc, bankname } = this.state;
        const { hideComponent } = this.state;
        const { moreinfo } = this.state;


        let ranges = {
            "Today Only": [moment(this.state.start), moment(this.state.end)],
            "Yesterday Only": [
                moment(this.state.start).subtract(1, "days"),
                moment(this.state.end).subtract(1, "days")
            ],
            "3 Days": [moment(this.state.start).subtract(3, "days"), moment(this.state.end)],
            "5 Days": [moment(this.state.start).subtract(5, "days"), moment(this.state.end)],
            "1 Week": [moment(this.state.start).subtract(7, "days"), moment(this.state.end)],
            "2 Weeks": [moment(this.state.start).subtract(14, "days"), moment(this.state.end)],
            "1 Month": [moment(this.state.start).subtract(1, "months"), moment(this.state.end)],
            "1 Year": [moment(this.state.start).subtract(1, "years"), moment(this.state.end)]
        };
        let local = {
            "format": "DD-MM-YYYY HH:mm",
            "sundayFirst": false
        }
        // let maxDate = moment(start).add(24, "hour")
        return (
            <div>
                {!hideComponent && (
                    <>
                        <Col md={12} lg={12}>
                            <Card>

                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <h5><b>SMS Notifications</b></h5><br />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="col-md-4 ">
                                                {/* <DateTimeRangeContainer
                                                    ranges={ranges}
                                                    start={this.state.start}
                                                    end={this.state.end}
                                                    local={local}
                                                    // maxDate={maxDate}
                                                    applyCallback={this.applyCallback}>
                                                    <FormControl
                                                        id="formControlsTextB"
                                                        type="text"
                                                        label="Text"
                                                        placeholder="Filter by Date"
                                                    />
                                                </DateTimeRangeContainer> */}
                                                {/* <button className=" float-right btn btn-primary btn-sm" onClick={e => {
                                                        this.toggleModal(e);
                                                    }} >Filter by date</button> */}
                                                {/* <input id="input" type="text" readOnly /> */}
                                            </div>
                                        </div>
                                        <div className="col-md-6">

                                            <button className="float-right" title="refresh" style={{ background: "white", border: "0px" }}
                                                onClick={this.getDataUpdate}>
                                                <RefreshIcon />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-12"><br />

                                        <h5>Total SMS: <b>{this.state.total}</b></h5><br />

                                        <ReactDatatable
                                            config={this.config}
                                            records={this.state.data}
                                            columns={this.columns}
                                            dynamic={true}
                                            id="tsc"
                                            loading={this.state.isLoading}
                                            total_record={this.state.total}
                                            onChange={this.tableChangeHandler} />

                                    </div>



                                </CardBody>
                            </Card>
                        </Col >
                    </>
                )
                }
            </div>
        )
    }
}
export default withTranslation('common')(SMS);
